import React from 'react';
import ColegioService from '../../services/ColegioService';

const badgeStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.4rem',
  padding: '0.35rem 0.7rem',
  borderRadius: '999px',
  background: 'rgba(56,189,248,0.12)',
  color: '#0f172a',
  border: '1px solid rgba(56,189,248,0.4)',
  fontWeight: 600,
  fontSize: '0.85rem',
  whiteSpace: 'nowrap'
};

const ActiveColegioBadge = () => {
  const colegio = ColegioService.getActiveColegio();
  if (!colegio) return null;

  const name = colegio.nombre || colegio.name || colegio.descripcion || colegio.detalle || 'Colegio';

  return (
    <div style={badgeStyle} title="Colegio activo">
      <i className="fas fa-map-marker-alt" aria-hidden="true" />
      <span>{name}</span>
    </div>
  );
};

export default ActiveColegioBadge;
